import { render, staticRenderFns } from "./MatchGapStep.vue?vue&type=template&id=b1bda6b8"
import script from "./MatchGapStep.vue?vue&type=script&lang=js"
export * from "./MatchGapStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports